<template>
  <div id="other-article">
    <div class="header">
      <span class="header-title">ข่าวอื่นๆ</span>
    </div>
    <div
      v-for="(article, index) in articles.slice(0,page)"
      :key="index"
      class="post-card"
      data-action="open_post"
      :data-postid="article.id"
      data-listname="home_feed"
      @click="open(article.link+'?webview=line&bt_id=71')"
    >
      <div class="image">
        <img class="thumbnail" :src="article.post_thumbnail_url" />
      </div>
      <div class="content">
        <div class="description">
          <p class="block-ellipsis" v-html="article.title ? article.title.rendered : ''"></p>
          <p class="block-ellipsis-desc" v-html="article.brief ? article.brief : ''"></p>
        </div>
      </div>
    </div>
    <infinite-loading v-if="articles.length" spinner="waveDots" @infinite="infiniteHandler">
      <div slot="no-results">คุณเห็นข่าวทั้งหมดแล้ว</div>
      <div slot="no-more">คุณเห็นข่าวทั้งหมดแล้ว</div>
    </infinite-loading>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      articles: [],
      page: 10,
    };
  },
  props: {
    isHighlightArticle: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    this.getArticle();
  },
  methods: {
    ...mapActions("article", ["findTagsByTagName", "findArticleByParams"]),
    async getArticle() {
      try {
        // const { data: config } = await axios.get("/config/ltf-rmf-config.json");
        // let { data: highlight } = await getPostByID(config.highlight_article);
        // if (highlight && Array.isArray(highlight)) {
        //   this.highlight = highlight[highlight.length - 1];
        // }

        // this.rmf = config.rmf;
        // this.ltf = config.ltf;

        let obj = {
          per_page: this.page
        };
        // console.log('get api: ', obj);

        const rs_article = await this.findArticleByParams(obj);
        // let obj = {

        //   search: this.detail.short_code,
        //   per_page: 5
        // };
        // const rs_article = await this.findArticleByParams(obj);
        if (rs_article && rs_article.length > 0) {
          this.articles = this.isHighlightArticle ? rs_article : rs_article.slice(1);
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    open(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
    async infiniteHandler($state) {
      if (this.page <= 100) {
        this.page += 10;
        this.getArticle();
        setTimeout(() => {
          $state.loaded();
        }, 1000);
      } else {
        $state.complete();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$radius-size: 8px;
#other-article {
  .header {
    i {
      color: $color-normal-text;
    }
    .header-title {
      display: inline-block;
      margin-left: 8px;
      @extend %font-size-m;
      font-weight: bold;
      color: $color-normal-text;
    }
  }
  .post-card {
    pointer-events: auto;
    margin: 16px 0;
    background-color: $color-white;
    border-radius: $radius-size;
    -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    .image {
      pointer-events: none;
      @include multipleResponsive(phablet, tablet) {
        @include finCol(6, 12, 16px, top, true, true);
      }
      .thumbnail {
        pointer-events: none;
        border-top-left-radius: $radius-size;
        border-top-right-radius: $radius-size;
        display: block;
        width: 100%;
        object-fit: cover;
        @include multipleResponsive(phablet, tablet) {
          border-top-right-radius: 0;
          border-bottom-left-radius: $radius-size;
        }
      }
    }
    .content {
      pointer-events: none;
      @include multipleResponsive(phablet, tablet) {
        @include finCol(6, 12, 16px, middle, true, true);
        padding: 0 16px;
        vertical-align: text-bottom;
      }
      .description {
        pointer-events: none;
        @extend %font-size-ss;
        font-weight: bold;
        color: $color-normal-text;
        padding: 16px;
        margin: 0px;
        .block-ellipsis {
          display: block;
          margin: 0;
          @include multipleResponsive(phablet, tablet, desktop) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 5px;
          }
        }
        .block-ellipsis-desc {
          display: block;
          margin: 0; // 0 auto
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 2;
          height: 50px;
          font-weight: normal;
          @include multipleResponsive(mobile) {
            display: none;
            color: $color-secondary-text;
          }
        }
      }
      .readmore {
        pointer-events: none;
        text-decoration: underline;
        color: $color-primary;
        margin-left: 2px;
        min-width: 3.9em;
        display: inline-block;
      }
    }
  }
}
</style>